import useSWR from 'swr'
import API from '../../../utils/api'
import { getPersistData } from '../../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/dashboard/compare' // (8) 지난달 대비 입금 금액
let swrData: any = getPersistData(KEY)

export function useCompare() {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY,
		async () => {
			const response = await API.get(KEY, token + '', {})
			swrData = response.result?.result

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
    compareData: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}